import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'configuration-planning-tab-2-part',
	standalone: true,
	templateUrl: './configuration-planning-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./configuration-planning-tab-2.part.scss`],
})
export class ConfigurationPlanningTab2Part {
}
